import { Box, Flex } from '@ouster/webviz-react-components';

import { MdCheck } from 'react-icons/md';

import { STEP_LABELS } from './constants';

interface StepperHeaderProps {
  currentStep: number;
}

export default function StepperHeader({ currentStep }: StepperHeaderProps) {
  return (
    <Flex
      data-testid="merge-stepper"
      border="1px solid"
      borderColor="whiteAlpha.200"
      borderRadius={8}
      p={3}
      gap={2}
      flexWrap="wrap"
    >
      {STEP_LABELS.map((label, idx) => {
        const isCompleted = idx < currentStep;
        const isCurrent = idx === currentStep;
        const isNotStarted = idx > currentStep;
        const stateColor = isCompleted
          ? 'green.400'
          : isCurrent
          ? 'blue.300'
          : 'gray.400';

        return (
          <Flex key={label} alignItems="center" flex={1}>
            <Flex
              w={8}
              h={8}
              borderRadius="full"
              alignItems="center"
              justifyContent="center"
              border="1px solid"
              borderColor={stateColor}
              color={stateColor}
              bg={isCompleted ? 'green.900' : 'transparent'}
              fontSize={12}
              fontWeight={700}
            >
              {isCompleted ? <MdCheck size={18} /> : idx + 1}
            </Flex>
            <Box ml={3} mr={2} minW={0}>
              <Box
                fontSize={13}
                color={stateColor}
                fontWeight={isCurrent ? 700 : 600}
                letterSpacing="0.04em"
              >
                {label}
              </Box>
            </Box>
            {idx < STEP_LABELS.length - 1 ? (
              <Box
                h="1px"
                flex={1}
                bg={
                  isCompleted
                    ? 'green.400'
                    : isNotStarted
                    ? 'gray.400'
                    : 'blue.400'
                }
                opacity={0.5}
                mr={2}
              />
            ) : null}
          </Flex>
        );
      })}
    </Flex>
  );
}
